import Footer from "./Footer";
import LandHeader from "./LandHeader";








export default function Confirmation(){

    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical !== null) {
    canonical.href = `https://sinatether.com/confirmation`;
    }



    return(
    
    <>

    <LandHeader/>


    <div>

    <div className="about-us-main">

     
    


    

    </div>


    <div className="card-about-content">


        <img className="img43435" src="https://static.sinatether.com/images/main-logo.svg" alt="درباره صرافی ارز دیجیتال سینا تتر"/>


        <div>

            <p className="content200">

             صرافی سینا تتر برخواسته از شرکت سینا اکسین رایان،مالکیت شناسه اپلیکیشن com.sinatether را تایید میکند.


            </p>



        </div>


    </div>
        
    </div>






    <Footer/>



 


    
    
    
    </>
    
    )
}